import { useFormikContext } from 'formik';
import { useCallback } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { SingleImageUpload } from '@hivebrite/design-system/SingleImageUpload';

import { type FormValues } from '../types';

export const Logo = () => {
  const { setFieldValue, values } = useFormikContext<FormValues>();

  const handleChange = useCallback(
    (_: File | null, file?: ArrayBuffer | string | null) => {
      setFieldValue('logo', file ?? null);
      setFieldValue('sync_to_org_logo', false);
    },
    [setFieldValue],
  );

  return (
    <Box mx={0} pb={{ s: 6, m: 0 }} pr={{ m: 6 }}>
      <SingleImageUpload
        height="175px"
        initialPreview={values.logo_original_url}
        label={s__('JobForm|Recommended size 300x300px (Max 8MB)')}
        name="logo"
        onChange={handleChange}
        removable={false}
        width="175px"
      />
    </Box>
  );
};
